import React from "react";
import "../../css/uploader.css";
import UploaderAraEncapsulated from "../Updloader/UploaderAraEncapsulated";

function UploadMobile(props) {
  return (
    <div className="tab-container-white-mobile">
      <div className="upload-content-container-mobile">
        <div className="upload-ara-column">
          <UploaderAraEncapsulated {...props} fileField="fileUrlsGeneralDocs" storageFolder="Documents/GeneralDocs" inputId="generalDocumentsUploadFilesMobile" uploadTitle="Upload general documents" uploadDescription="Add up to 3 files. Uploads start automatically after selection." />
        </div>
        <div className="upload-ara-column">
          <UploaderAraEncapsulated {...props} fileField="fileUrlsTherapistDoc" storageFolder="Documents/TherapistDocs" inputId="therapistDocumentsUploadFilesMobile" uploadTitle="Upload therapist documents" uploadDescription="Add up to 3 files. Uploads start automatically after selection." />
        </div>
      </div>
    </div>
  );
}

export default UploadMobile;
